import Header from '../../components/Header';
import User from "../../components/User";
import Contato from "../../components/Contatos";
import Sobre from "../../components/Sobre";
import Ferramentas from "../../components/Ferramentas";

import './home.css';


export default function Home() {
    return(
        <div className="App">
            <Header />
            <User />
            <Contato />
            <Sobre />
            <Ferramentas />
        </div>
    )
}